import { API_STATES } from "@/helpers";
const state = {
  departmentsGetState              : API_STATES.NOT_REQUESTED,
  departmentsGetError              : null,
  departmentDeleteState            : API_STATES.NOT_REQUESTED,
  departmentDeleteError            : null,
  departmentCreateState            : API_STATES.NOT_REQUESTED,
  departmentCreateError            : null,
  departments                      : [],
  departmentUpdateState            : API_STATES.NOT_REQUESTED,
  departmentUpdateError            : null,
  userDepartmentUpdating           : [],
  userDepartmentUpdateError        : null,
  userDepartmentDeleting           : [],
  userDepartmentDeleteSuccessError : null,
  userDepartments                  : [],
  department                       : {}
};

export default state;
